import React from "react";

function About() {
  return (
    
            
            
    <div>
        <div class="page-header">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2>Our About Us</h2>
                            <h5 style={{'color':'white'}}>“Delivering high-quality IT services with a focus on performance, security, and customer satisfaction.”</h5>
                        </div>
                      
                    </div>
                </div>
            </div>
      {/* About Section */}
      <div className="about">
        <div className="container-fluid">
          <div className="row align-items-center">

            <div className="col-md-6">
              <img src="https://thumbs.dreamstime.com/b/businessman-behalf-company-welcoming-young-male-employee-boardroom-meeting-introducing-hired-worker-office-getting-182382430.jpg" alt="About" />
            </div>

            <div className="col-md-6">
              <h2 className="section-title">Complete Managing About Software Business</h2>
              <p>
         

<b>LTH IT Solution Pvt. Ltd.</b> is a trusted IT training and development company established in 2026. We provide <b>online and offline  live software training</b> for students, freshers, and working professionals.

Our focus is on <b>practical, job-oriented learning</b> with real-time projects to make you industry-ready. We aim to help individuals build strong IT skills and achieve successful careers in the technology field.

              </p>
              <p>
                We offer industry-focused training in domains like <b>Full Stack Development, Python, Web Development, and other in-demand technologies, combined with hands-on projects, real-time practice, and dedicated placement support</b> to help candidates secure the right career opportunities.</p>
              <button className="btn">Learn More</button>
            </div>

          </div>
        </div>
      </div>

      {/* Story Section */}
      <div className="story">
        <div className="container-fluid">

          <div className="section-header">
            <h2>Our Story</h2><br/>
            <p>LTH IT Solution Pvt. Ltd. was founded with a vision to provide practical, industry-oriented IT training and help students build successful careers in the technology field.</p>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="story-container">

                <div className="story-end">
                  <p>Now</p>
                </div>

                <div className="story-continue">

                  {/* Right */}
                  <div className="row story-right">
                    <div className="col-md-6">
                      <p className="story-date">15 March 2026</p>
                    </div>
                    <div className="col-md-6">
                      <div className="story-box">
                        <div className="story-icon">
                          <i className="fa fa-gift"></i>
                        </div>
                        <div className="story-text">
                          <h3>LTH IT Solution Pvt. Ltd. started as a small training initiative with the vision of providing practical IT skills to students and job seekers.</h3>
                        
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Left */}
                  <div className="row story-left">
                    <div className="col-md-6">
                      <div className="story-box">
                        <div className="story-icon">
                          <i className="fa fa-business-time"></i>
                        </div>
                        <div className="story-text">
                          <h3>Started working on real-time projects and providing internship opportunities to enhance practical knowledge.</h3>
                        
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <p className="story-date">25 March 2026</p>
                    </div>
                  </div>

                  {/* Year */}
                  <div className="row">
                    <div className="col-12">
                      <div className="story-year">
                        <p>2026</p>
                      </div>
                    </div>
                  </div>

                  {/* More Items */}
                  <div className="row story-right">
                    <div className="col-md-6">
                      <p className="story-date">01 April 2026</p>
                    </div>
                    <div className="col-md-6">
                      <div className="story-box">
                        <div className="story-icon">
                          <i className="fa fa-briefcase"></i>
                        </div>
                        <div className="story-text">
                          <h3>Launched dedicated placement guidance programs to help students secure job opportunities.</h3>
                        
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                {/* Start */}
                <div className="story-start">
                  <p>Launch</p>
                </div>

                <div className="story-launch">
                  <div className="story-box">
                    <div className="story-text">
                      <h3>Today, LTH IT Solution Pvt. Ltd. is a growing IT company offering services in software development, web development, and other IT solutions, along with strong career support.
</h3>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
}

export default About;